<template>
  <div>
    <vue-portal to="hrsys-navbar-actions">
      <vx-tooltip :text="$t('buttons.create')" class="ml-2" position="bottom">
        <base-button @click="createPayment" class="self-end px-3" icon="plus"/>
      </vx-tooltip>
    </vue-portal>

    <base-loader :loading="loadingContent">
      <div class="view-container" v-if="summary.paid">
        <div class="flex">
          <div class="w-1/4">
            <span class="font-bold">{{$t('payments.estimation')}}</span>: {{summary.estimation}}
          </div>
          <div class="w-1/4">
            <span class="font-bold">{{$t('payments.estimated_payment')}}</span>: {{summary.estimated_payment}}{{summary.currency | currency}}
          </div>
          <div class="w-1/4">
            <span class="font-bold">{{$t('payments.paid')}}</span>: {{summary.paid}}{{summary.currency | currency}}
          </div>
          <div class="w-1/4">
            <span class="font-bold">{{$t('payments.to_pay')}}</span>: {{summary.to_pay}}{{summary.currency | currency}}
          </div>
        </div>
      </div>

      <div class="view-container">
        <payments-table :header="tableHeader"
                        :payments="payments"
                        @refresh="getPaymentInfo"
        />
      </div>
    </base-loader>
  </div>
</template>

<script>
  import PaymentsTable from "../../components/payments/PaymentsTable";
  import Payments from "../../services/Payments";
  import EventBus from "../../utilities/eventBus";

  export default {
    name: 'ProjectFinance',
    components: {
      PaymentsTable,
    },
    data () {
      return {
        summary: {},
        payments: [],
        projectId: null,
        loadingContent: false
      }
    },
    computed: {
      tableHeader () {
        return ([
          this.$t('payments.table.amount'),
          this.$t('payments.table.status'),
          this.$t('payments.table.sent_at'),
          this.$t('payments.table.paid_at'),
          this.$t('payments.table.actions'),
        ])
      },
    },
    methods: {
      async getPaymentInfo () {
        this.loadingContent = true;
        const [summary, payments] = await Promise.all([
          Payments.getProjectInfo(this.projectId),
          Payments.list({projectId: this.projectId, perPage: 100})
        ]);
        this.summary = summary.data;
        this.payments = payments.data;
        this.loadingContent = false;
      },
      createPayment () {
        EventBus.$emit('openCreatePaymentModal', {
          project_id: this.projectId,
          hideProject: true,
        });
      }
    },
    beforeDestroy () {
      EventBus.$off('paymentCreated');
    },
    mounted () {
      this.projectId = parseInt(this.$route.params.id);
      this.getPaymentInfo();
      EventBus.$on('paymentCreated', () => {
        this.getPaymentInfo();
      });
    }
  }
</script>

<style scoped>

</style>
